import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '@settings/api/mutations'
import {invalidateSettingsQuery} from '@settings/modules/common/providers'
import type {ErrorResponse} from '@settings/modules/common/types'
import {notifyIfErrorMessage} from '@settings/modules/common/utils'

export const useDeleteGrindingCircuit = (onSuccess: () => void) => {
  const {t} = useTranslation()
  const {notify} = useNotification()
  const raiseError = useErrorHandler()

  return useMutation<
    void,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.deleteGrindingCircuit>[0]
  >({
    mutationFn: mutations.deleteGrindingCircuit,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.deleteGrindingCircuit'))
      onSuccess()
    },
    onSettled: () => {
      invalidateSettingsQuery('grindingCircuits')
    }
  })
}
